module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#rain",
      toString: function () {
        return this.url;
      }
    }